<template>
  <MBZCTAButton
    :severity="menuOpen ? '' : 'secondary'"
    label="Log in"
    :button-url="{
      title: 'Log in',
      href: '/user/login',
    }"
    :icon="menuOpen ? 'chevronUp' : 'chevronDown'"
    @click.prevent="toggle"
  />

  <Menu
    ref="loginMenu"
    :model="items"
    :popup="true"
    :pt="{
      root: {
        class: 'bg-mbzuai-sand-50 border-none py-4 px-3 mt-1',
      },
      submenuLabel: { class: 'hidden' },
      list: {
        class: 'flex flex-col gap-3',
      },
      itemContent: { class: 'hover:bg-transparent! bg-transparent' },
      itemLabel: {
        class: 'text-mbzuai-dark-navy-500 no-underline!',
      },
    }"
    @hide="menuOpen = false"
    @show="menuOpen = true"
  >
    <template #item="data">
      <NuxtLink
        :to="data.item.url"
        target="_blank"
        class="text-body-small hover:underline-offset-2 hover:underline! decoration-mbzuai-navy-400! decoration-2! text-mbzuai-navy-500! px-2 no-underline!"
      >
        {{ data.item.label }}
      </NuxtLink>
    </template>
  </Menu>
</template>

<script setup lang="ts">
const loginMenu = ref();
const items = ref([
  {
    items: [
      {
        label: 'Student Login',
        url: 'https://mbzuaiac.sharepoint.com/Student/Pages/default.aspx',
      },
      {
        label: 'Staff Login',
        url: 'https://mbzuaiac.sharepoint.com/Staff/Pages/default.aspx',
      },
    ],
  },
]);

const menuOpen = ref(false);

const toggle = (event) => {
  loginMenu.value.toggle(event);
};
</script>
